"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withFieldControl = exports.withControl = exports.useValidation = exports.useInputClassNames = exports.useForm = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Field = _interopRequireDefault(require("../components/form/Field"));
var _Control = _interopRequireDefault(require("../components/form/Control"));
var _CoreProps = require("./CoreProps");
var _ErrorMessage = _interopRequireDefault(require("../components/form/ErrorMessage"));
var _validations = require("../components/form/validations");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } /* eslint-disable import/prefer-default-export */
const useInputClassNames = _ref => {
  let {
    size,
    rounded,
    focused,
    hovered,
    darkBackground,
    isStatic
  } = _ref;
  return (0, _classnames.default)({
    [`is-${size}`]: size,
    'is-rounded': rounded,
    'is-focused': focused,
    'is-hovered': hovered,
    'is-static': isStatic,
    'has-dark-background': darkBackground
  });
};
exports.useInputClassNames = useInputClassNames;
const useForm = () => {
  //Form values
  const [values, setValues] = (0, _react.useState)({});
  //Errors
  const [errors, setErrors] = (0, _react.useState)({});
  const handleSubmit = event => {
    if (event) event.preventDefault();
    if (Object.keys(errors).length === 0 && Object.keys(values).length !== 0) {
      callback();
    } else {
      alert('There is an Error!');
    }
  };
  return {
    values,
    errors,
    handleChange,
    handleSubmit
  };
};
exports.useForm = useForm;
const useValidation = (validators, props) => {
  const [error, setError] = (0, _react.useState)(props.error);
  const [valid, setValid] = (0, _react.useState)(props.valid);
  (0, _react.useEffect)(() => {
    setError(props.error);
  }, [props.error]);
  const validate = (value, onWhat) => {
    let validatorResults = null;
    if (validators) {
      var _validatorResults, _validatorResults2;
      validatorResults = {
        valid: true
      };
      for (let i = 0; i < validators.length; i++) {
        const item = validators[i];
        if (typeof item.event === 'undefined' || item.event === onWhat || Array.isArray(item.event) && item.event.includes(onWhat)) {
          const result = item.validate(value, props);
          if (typeof (result === null || result === void 0 ? void 0 : result.valid) !== 'undefined' && !result.valid) {
            validatorResults = result;
            break;
          }
        }
      }
      if (validatorResults && !((_validatorResults = validatorResults) !== null && _validatorResults !== void 0 && _validatorResults.valid)) {
        setValid(false);
        setError(validatorResults.error);
        return [false, validatorResults.error];
      }
      if (validatorResults && (_validatorResults2 = validatorResults) !== null && _validatorResults2 !== void 0 && _validatorResults2.valid) {
        setValid(true);
        setError(null);
        return [true, undefined];
      }
    }
  };
  return [valid, error, validate];
};
exports.useValidation = useValidation;
const wrapperPropTypes = {
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  readonly: _propTypes.default.bool,
  field: _propTypes.default.bool,
  control: _propTypes.default.bool,
  label: _propTypes.default.string,
  color: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  tooltipText: _propTypes.default.string,
  isHorizontal: _propTypes.default.bool,
  validationIcon: _propTypes.default.bool,
  validationColoring: _propTypes.default.bool,
  min: _propTypes.default.number,
  max: _propTypes.default.number,
  minLength: _propTypes.default.number,
  pattern: _propTypes.default.string,
  layout: _propTypes.default.oneOf(['horizontal', 'vertical']),
  'data-testid': _propTypes.default.string,
  size: _propTypes.default.oneOfType([_propTypes.default.oneOf(['normal', 'small', 'medium', 'large']), _propTypes.default.string]),
  iconLeft: _propTypes.default.string,
  iconRight: _propTypes.default.string,
  iconSize: _propTypes.default.oneOfType([_propTypes.default.oneOf(['normal', 'small', 'medium', 'large']), _propTypes.default.string]),
  expanded: _propTypes.default.bool,
  isLoading: _propTypes.default.bool,
  required: _propTypes.default.bool,
  error: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
  validators: _propTypes.default.arrayOf(_propTypes.default.shape({
    validate: _propTypes.default.func,
    args: _propTypes.default.object
  })),
  onChange: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  disableDefaultValidation: _propTypes.default.bool,
  controlError: _propTypes.default.bool
};
const InnerFieldWrapper = _ref2 => {
  let {
    children,
    isHorizontal
  } = _ref2;
  return isHorizontal ? /*#__PURE__*/_react.default.createElement(_Field.default, null, children) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
};
InnerFieldWrapper.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  isHorizontal: _propTypes.default.bool
};
const withFieldControl = (Component, overrides) => {
  const Wrapper = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
    const inputClassNames = useInputClassNames(props);
    const classNames = (0, _CoreProps.useClassNames)(props);
    let {
      validators
    } = props;
    if (!validators) {
      validators = [];
    }
    if (!props.disableDefaultValidation) {
      if (props.required && !validators.some(item => item.name === 'required')) {
        validators.push(_validations.defaultValidations.required);
      }
      if (props.min && !validators.some(item => item.name === 'min')) {
        validators.push(_validations.defaultValidations.min);
      }
      if (props.max && !validators.some(item => item.name === 'max')) {
        validators.push(_validations.defaultValidations.max);
      }
      if (props.pattern && !validators.some(item => item.name === 'pattern')) {
        validators.push(_validations.defaultValidations.pattern);
      }
      if (props.minLength && !validators.some(item => item.name === 'minLength')) {
        validators.push(_validations.defaultValidations.minLength);
      }
    }
    const [valid, error, validate] = useValidation(validators, props);
    let validClassName = props.controlError;
    if (!props.controlError && (props.validationColoring || typeof props.validationColoring === 'undefined' && overrides !== null && overrides !== void 0 && overrides.validationColoring)) {
      validClassName = error || props.error ? 'is-danger' : undefined;
      validClassName = !validClassName && valid ? 'is-success' : validClassName;
    }
    let {
      iconRight
    } = props;
    if (props.controlError) {
      iconRight = 'warning';
    }
    if (!iconRight && (props.validationIcon || typeof props.validationIcon === 'undefined' && overrides !== null && overrides !== void 0 && overrides.validationIcon)) {
      iconRight = error || props.error ? 'warning' : iconRight;
      iconRight = !iconRight && valid ? 'check' : iconRight;
    }
    const onBlurInternal = value => {
      const [validArg, errorArg] = validate(value, 'blur');
      if (props.onBlur) {
        props.onBlur(value, validArg, errorArg);
      }
    };
    const onChangeInternal = value => {
      const [validArg, errorArg] = validate(value, 'change');
      if (props.onChange) {
        props.onChange(value, validArg, errorArg);
      }
    };
    const newProps = {
      ...props
    };
    if (props.onBlur) {
      delete newProps.onBlur;
    }
    if (props.onChange) {
      delete newProps.onChange;
    }
    if (props.field || props.label) {
      return /*#__PURE__*/_react.default.createElement(_Field.default, {
        label: props.label,
        tooltipText: props.tooltipText,
        required: props.required,
        isHorizontal: props.isHorizontal,
        size: props.size,
        className: (0, _classnames.default)(classNames) || undefined,
        "data-testid": props['data-testid']
      }, /*#__PURE__*/_react.default.createElement(InnerFieldWrapper, {
        isHorizontal: props.isHorizontal
      }, props.control && (typeof props.layout === 'undefined' || props.layout === 'horizontal') && /*#__PURE__*/_react.default.createElement(_Control.default, {
        iconLeft: props.iconLeft,
        iconRight: iconRight,
        iconSize: props.iconSize ?? props.size,
        size: props.size ?? props.iconSize,
        expanded: props.expanded,
        isLoading: props.isLoading,
        color: error || props.error ? 'danger' : undefined
      }, /*#__PURE__*/_react.default.createElement(Component, _extends({
        ref: ref,
        className: (0, _classnames.default)(inputClassNames, classNames, validClassName) || undefined,
        disabled: props.disabled,
        readonly: props.readonly,
        error: error || props.error,
        placeholder: props.placeholder,
        onChange: val => onChangeInternal(val),
        onBlur: val => onBlurInternal(val)
      }, newProps)))), (!props.control || props.layout === 'vertical') && /*#__PURE__*/_react.default.createElement(Component, _extends({
        ref: ref,
        className: (0, _classnames.default)(inputClassNames, classNames, validClassName) || undefined,
        disabled: props.disabled,
        readonly: props.readonly,
        placeholder: props.placeholder,
        error: error || props.error,
        onChange: val => onChangeInternal(val),
        onBlur: val => onBlurInternal(val)
      }, newProps)), (error || props.error) && /*#__PURE__*/_react.default.createElement(_ErrorMessage.default, null, error || props.error));
    }
    if (props.control && (typeof props.layout === 'undefined' || props.layout === 'horizontal')) {
      return /*#__PURE__*/_react.default.createElement(_Control.default, {
        iconLeft: props.iconLeft,
        iconRight: iconRight,
        iconSize: props.iconSize,
        size: props.size,
        expanded: props.expanded,
        isLoading: props.isLoading,
        color: props.error ? 'danger' : props.color,
        "data-testid": props['data-testid']
      }, /*#__PURE__*/_react.default.createElement(Component, _extends({
        ref: ref,
        className: (0, _classnames.default)(inputClassNames, classNames, validClassName) || undefined,
        disabled: props.disabled,
        readonly: props.readonly,
        placeholder: props.placeholder,
        error: error || props.error,
        onChange: val => onChangeInternal(val),
        onBlur: val => onBlurInternal(val)
      }, newProps)));
    }
    return /*#__PURE__*/_react.default.createElement(Component, _extends({
      ref: ref,
      className: (0, _classnames.default)(inputClassNames, classNames, validClassName) || undefined,
      disabled: props.disabled,
      readonly: props.readonly,
      placeholder: props.placeholder,
      error: error || props.error,
      onChange: val => onChangeInternal(val),
      onBlur: val => onBlurInternal(val),
      "data-testid": props['data-testid']
    }, newProps));
  });
  Wrapper.displayName = 'withFieldControl';
  Wrapper.propTypes = wrapperPropTypes;
  Wrapper.defaultProps = {
    field: true,
    control: true
  };
  return Wrapper;
};
exports.withFieldControl = withFieldControl;
const withControl = (Component, overrides) => {
  const Wrapper = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
    const inputClassNames = useInputClassNames(props);
    const classNames = (0, _CoreProps.useClassNames)(props);
    let {
      validators
    } = props;
    if (!validators) {
      validators = [];
    }
    if (!props.disableDefaultValidation) {
      if (props.required && !validators.some(item => item.name === 'required')) {
        validators.push(_validations.defaultValidations.required);
      }
      if (props.min && !validators.some(item => item.name === 'min')) {
        validators.push(_validations.defaultValidations.min);
      }
      if (props.max && !validators.some(item => item.name === 'max')) {
        validators.push(_validations.defaultValidations.max);
      }
      if (props.pattern && !validators.some(item => item.name === 'pattern')) {
        validators.push(_validations.defaultValidations.pattern);
      }
      if (props.minLength && !validators.some(item => item.name === 'minLength')) {
        validators.push(_validations.defaultValidations.minLength);
      }
    }
    const [valid, error, validate] = useValidation(validators, props);
    let validClassName = props.controlError;
    if (!props.controlError && (props.validationColoring || typeof props.validationColoring === 'undefined' && overrides !== null && overrides !== void 0 && overrides.validationColoring)) {
      validClassName = error || props.error ? 'is-danger' : undefined;
      validClassName = !validClassName && valid ? 'is-success' : validClassName;
    }
    let {
      iconRight
    } = props;
    if (props.controlError) {
      iconRight = 'warning';
    }
    if (!iconRight && (props.validationIcon || typeof props.validationIcon === 'undefined' && overrides !== null && overrides !== void 0 && overrides.validationIcon)) {
      iconRight = error || props.error ? 'warning' : iconRight;
      iconRight = !iconRight && valid ? 'check' : iconRight;
    }
    const onBlurInternal = value => {
      const [validArg, errorArg] = validate(value, 'blur');
      if (props.onBlur) {
        props.onBlur(value, validArg, errorArg);
      }
    };
    const onChangeInternal = value => {
      const [validArg, errorArg] = validate(value, 'change');
      if (props.onChange) {
        props.onChange(value, validArg, errorArg);
      }
    };
    const newProps = {
      ...props
    };
    if (props.onBlur) {
      delete newProps.onBlur;
    }
    if (props.onChange) {
      delete newProps.onChange;
    }
    if (props.control && (typeof props.layout === 'undefined' || props.layout === 'vertical')) {
      return /*#__PURE__*/_react.default.createElement(_Control.default, {
        iconLeft: props.iconLeft,
        iconRight: iconRight,
        iconSize: props.iconSize,
        size: props.size,
        expanded: props.expanded,
        isLoading: props.isLoading,
        color: error || props.error ? 'danger' : props.color,
        "data-testid": props['data-testid'],
        className: props.layout === 'vertical' ? 'control-layout--vertical' : undefined
      }, /*#__PURE__*/_react.default.createElement(Component, _extends({
        ref: ref,
        className: (0, _classnames.default)(inputClassNames, classNames, validClassName) || undefined,
        disabled: props.disabled,
        readonly: props.readonly,
        placeholder: props.placeholder,
        error: error || props.error,
        onChange: val => onChangeInternal(val),
        onBlur: val => onBlurInternal(val)
      }, newProps)));
    }
    return /*#__PURE__*/_react.default.createElement(Component, _extends({
      ref: ref,
      className: (0, _classnames.default)(inputClassNames, classNames, validClassName) || undefined,
      disabled: props.disabled,
      readonly: props.readonly,
      placeholder: props.placeholder,
      error: error || props.error,
      onChange: val => onChangeInternal(val),
      onBlur: val => onBlurInternal(val),
      "data-testid": props['data-testid']
    }, newProps));
  });
  Wrapper.displayName = 'withControl';
  Wrapper.propTypes = wrapperPropTypes;
  Wrapper.defaultProps = {
    control: true
  };
  return Wrapper;
};
exports.withControl = withControl;
//# sourceMappingURL=CoreInput.js.map